export default __webpack_public_path__ + "static/media/Yellowpin.cb5abd79.svg";